import React, { Component } from "react";
import { Row, Col, ProgressBar, Image, Button } from "react-bootstrap";
import TutorReview from "./TutorReview";
import TutorEarning from "./TutorEarning";
import TutorView from "./TutorView";
class TutorResult extends Component {
  constructor() {
    super();

    this.state = {
      AllMessages: [],
      page: 1,
      paginationpages: 1,
      reviewArr: [
        {
          userName: "James Smith",
          subject: "Maths (GCSE)",
          address: "L15 2HY",
          date: "9 Dec 2020",
          message:
            "After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with.After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with",
        },
        {
          userName: "Sam J.",
          subject: "Maths (GCSE)",
          address: "L15 2HY",
          date: "9 Dec 2020",
          message:
            "After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with.After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with",
        },
        {
          userName: "Fred K",
          subject: "Maths (GCSE)",
          address: "L15 2HY",
          date: "9 Dec 2020",
          message:
            "After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with.After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with",
        },
      ],
      resultCategory: "Earning",
    };
  }

  componentDidMount = () => {
    // get Token
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;
  };

  render() {
    const { resultCategory } = this.state;

    return (
      <div className="container">
        <div className="tutor-result-div">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className="header">
                <h2>Results summary</h2>
              </div>
              <div className="tutor-result-btn">
                <Button
                  className={`${resultCategory === "Earning" ? "active" : ""}`}
                  onClick={() => {
                    this.setState({
                      resultCategory: "Earning",
                    });
                  }}
                >
                  Earning
                </Button>
                <Button
                  className={`${resultCategory === "Reviews" ? "active" : ""}`}
                  onClick={() => {
                    this.setState({
                      resultCategory: "Reviews",
                    });
                  }}
                >
                  Reviews
                </Button>
                <Button
                  className={`${resultCategory === "View" ? "active" : ""}`}
                  onClick={() => {
                    this.setState({
                      resultCategory: "View",
                    });
                  }}
                >
                  View
                </Button>
              </div>
            </Col>
          </Row>
          {resultCategory === "Earning" ? (
            <TutorEarning />
          ) : resultCategory === "Reviews" ? (
            <TutorReview />
          ) : resultCategory === "View" ? (
            <TutorView />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default TutorResult;
